export default {"src":"/_next/static/media/takeCare.e101ee00.svg","height":37,"width":45,"blurWidth":0,"blurHeight":0};